// CheckName.jsx
import { UserOutlined } from '@ant-design/icons';
import React from 'react';
import { debugLog } from '../../../utils/debug';
const CheckName = ({ data }) => {
    debugLog('CheckName data', data);

    const { incomeType, investorName, clientYes, description, client_details } = data;
    let label = 'Client';
    let clientnames = data.investorName;

    if (incomeType === 'investment') {
        label = 'Investor';
        clientnames = data.investorName;
    } else if (incomeType === 'premium') {
        label = 'Premium Member';
        clientnames = data.investorName;
    } else if (incomeType === 'other') {
        label = 'Other Client';
        clientnames = data.otherDetails;
    } else if (incomeType === 'invoice_payment') {
        label = 'Invoice Client';
        // Use client_details if available, otherwise fallback to clientYes
        if (client_details) {
            clientnames = client_details[0].display_name;
        } else if (clientYes) {
            clientnames = `Client ID: ${client_details[0] ? client_details[0].display_name : clientYes}`;
        } else {
            clientnames = 'Invoice Client';
        }
    }

    return (
        <span>
            <UserOutlined /> <strong>{label}:</strong> {clientnames || 'N/A'}
        </span>
    );
};

export default CheckName;
